(function() {
  var ceri;

  ceri = require("ceri/lib/wrapper");

  module.exports = function(obj) {
    if (obj.mixins == null) {
      obj.mixins = [];
    }
    obj.mixins.push(require("ce/structure"));
    obj.mixins.push(require("ce/tests"));
    return ceri(obj);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-dev-server/lib/createView.js
// module id = 72
// module chunks = 1